/**
 * Single source of truth for folder-document upload size limits on the client.
 * Must stay in sync with backend/MagiaLecha.Core/Constants/FileUploadLimits.cs
 *
 * Other upload flows (Masav, signed contracts, lead import) have their own,
 * intentionally different limits and must not use this module.
 */

export const MAX_FILE_SIZE_MB = 5;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const isFileSizeAllowed = (fileSize: number): boolean => fileSize <= MAX_FILE_SIZE_BYTES;

/** מחזיר הודעת שגיאה בעברית אם הקובץ חורג מהגודל המותר, אחרת null */
export const validateFileSize = (file: File): string | null =>
  isFileSizeAllowed(file.size) ? null : `גודל הקובץ חורג מהמותר (מקסימום ${MAX_FILE_SIZE_MB}MB)`;
